"use client";

import { isBackendConfigured } from "@/api/api-client";
import { ensureAztangofestDraftBookingFromSession } from "@/api/aztangofest/ensureAztangofestDraftBookingFromSession";
import {
    getAzDanceBookingToken,
    isAzDanceBookingTokenValid,
} from "@/lib/azdanceBookingSession";
import { formatApiError } from "@/lib/apiErrorMessage";
import { useRegistrationStore } from "@/state/stores/registrationStore";
import { toast } from "sonner";

/**
 * Подтягивает `eventBookingId` с сервера (`GET /azdance/profile/me`), если в сторе ещё пусто —
 * нужно для GET participants и т.п. Раньше вызывался удалённый `PUT …/cart/items` с quantity 0.
 */
export async function ensureFestDraftEventBookingIfMissing(
    language: string,
): Promise<void> {
    if (!isBackendConfigured()) return;
    if (useRegistrationStore.getState().dashboardEventBookingId?.trim()) return;
    const token = getAzDanceBookingToken();
    if (!token || !isAzDanceBookingTokenValid()) return;
    try {
        const eid = await ensureAztangofestDraftBookingFromSession({
            language,
            accessToken: token,
        });
        useRegistrationStore.getState().setDashboardEventBookingId(eid.trim());
    } catch (e) {
        toast.error(formatApiError(e));
    }
}
